// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// formik components
import { ErrorMessage, Field } from "formik";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftSelect from "components/SoftSelect";
import "./style.css";

import CountrySelectPhoneInput from "layouts/pages/account/company/components/Settings/components/CountrySelectPhoneInput";

function FormField({
  options,
  defaultValue,
  forWhat,
  label,
  name,
  forPhone,
  setFieldValue,
  isDisabled,
  ...rest
}) {
  return (
    <SoftBox>
      {forWhat === "Profile Info" ? (
        <SoftBox mb={1.5}>
          {label && (
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {label}
                {rest.required && <span style={{ color: "rgb(255, 102, 124)" }}> *</span>}
              </SoftTypography>
            </SoftBox>
          )}
          {!forPhone ? (
            <Field {...rest} name={name} as={SoftInput} />
          ) : (
            <CountrySelectPhoneInput name={name} setFieldValue={setFieldValue} {...rest} />
          )}
          <SoftBox mt={0.75}>
            <SoftTypography component="div" variant="caption" color="error">
              <ErrorMessage name={name} />
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      ) : (
        <SoftBox mb={1.5}>
          <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {label}
              {rest.required && <span style={{ color: "rgb(255, 102, 124)" }}> *</span>}
            </SoftTypography>
          </SoftBox>
          <Field name={name}>
            {({ field, form, meta }) => {
              const { touched } = form;
              const isError = Boolean(meta.error) && touched[field.name];
              return (
                <SoftSelect
                  defaultValue={defaultValue}
                  options={options}
                  // success={isSuccess}
                  error={isError}
                  onChange={({ value }) => {
                    form.setFieldValue(field.name, value);
                    // debouncedValidate();
                  }}
                  isDisabled={isDisabled}
                  onBlur={() => {
                    form.setFieldTouched(field.name, true);
                  }}
                />
              );
            }}
          </Field>
          <SoftBox mt={0.75}>
            <SoftTypography component="div" variant="caption" color="error">
              <ErrorMessage name={name} />
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      )}
    </SoftBox>
  );
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default FormField;
